export const TOPIC_FILTER_LABELS = {
  category: "主题（单选）",
  duration: "时长（可多选）",
} as const;
